// extracted by mini-css-extract-plugin
module.exports = {"headerPosition":"TextList_headerPosition__g6gyG","headerText":"TextList_headerText__vUNY1","root":"TextList_root__s8RG6","item":"TextList_item__mvaNn"};